<div class="flex flex-column gap-4 p-3 border-round-lg" style="background-color: #f9faea;" [formGroup]="activity">
  <div class="flex flex-column gap-3">
    <div class="flex align-items-center justify-content-between">
      <b class="w-full text-left font-medium text-gray-800 text-base">Add Experience</b>
      <p-button icon="pi pi-times" [rounded]="true" styleClass="closeIcon" (click)="removeActivity(index)"></p-button>
    </div>
    <div class="flex flex-column gap-1">
      <p-dropdown
        [ngClass]="{'ng-invalid ng-dirty': (submitted || activity.get('activityId')?.touched) && activity.get('activityId')?.invalid}"
        [options]="activities ?? []" styleClass="w-full border-1" optionLabel="name" optionValue="id"
        formControlName="activityId" [filter]="true" filterBy="name" (onChange)="onActivityChange($event, index)"
        [showClear]="true" appendTo="body" placeholder="Type to search activities">
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.name }}</div>
          </div>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ option.name }}</div>
          </div>
        </ng-template>
      </p-dropdown>
      <small class="ng-dirty ng-invalid text-red-500" *ngIf="activity.get('activityId')?.invalid &&
      (submitted || activity.get('activityId')?.touched)">
        Activity is required
      </small>
    </div>
    <input type="text"
      [ngClass]="{'ng-invalid ng-dirty': (submitted || activity.get('otherActivityName')?.touched) && activity.get('otherActivityName')?.invalid}"
      *ngIf="showOtherActivity(activity.get('activityId')?.value)" pInputText formControlName="otherActivityName"
      class="w-full" placeholder="Other Activity Name" />
    <small class="ng-dirty ng-invalid text-red-500" *ngIf="activity.get('otherActivityName')?.invalid &&
      (submitted || activity.get('otherActivityName')?.touched)">
      Other Activity Name is required
    </small>
  </div>

  <div class="flex flex-column gap-3">
    <div class="flex gap-2">
      <b class="w-auto inline-block text-left font-medium text-gray-800 text-base">Level of achievement</b>
      <div class="inline">
        <p-button (onClick)="showDialog()" icon="pi pi-question-circle" styleClass="show_dialog"></p-button>
        <p-dialog header="TIER DESCRIPTION" [modal]="true" [(visible)]="visible" [style]="{ width: '50rem' }"
          [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
          <div class="mb-4 flex flex-column gap-2">
            <p class="text-left font-normal text-sm text-gray-600"><b class="inline font-medium text-gray-800">If Extracurricular activity is chosen:</b>  </p>
            <p class="text-left font-normal text-sm text-gray-600"><b class="inline font-medium text-gray-800">Tier
                1</b> activities are rare and demonstrate exceptional
              achievement or leadership. </p>
            <b class="text-left font-normal text-sm text-gray-800">Eg : International level competitions,
              Olympiads etc. </b>
          </div>
          <div class="mb-4 flex flex-column gap-2">
            <p class="text-left font-normal text-sm text-gray-600"><b class="inline font-medium text-gray-800">Tier
                2</b> extracurriculars are endeavors that show high
              levels of achievement.</p>
            <b class="text-left font-normal text-sm text-gray-800">Eg : National level competitions, national
              sports team </b>
          </div>
          <div class="mb-4 flex flex-column gap-2">
            <p class="text-left font-normal text-sm text-gray-600"><b class="inline font-medium text-gray-800">Tier
                3</b> extracurricular activities demonstrate a
              student’s participation in pursuits outside of the classroom.</p>
            <b class="text-left font-normal text-sm text-gray-800">Eg : State level competitions, leading a
              school level club </b>
          </div>
          <div class="mb-4 flex flex-column gap-2">
            <p class="text-left font-normal text-sm text-gray-600"><b class="inline font-medium text-gray-800">Tier
                4</b> extracurricular activities are the most
              common activities.</p>
            <b class="text-left font-normal text-sm text-gray-800">Eg : being on the board of a school level
              club, participating in local organizations </b>
          </div>
        </p-dialog>
      </div>
    </div>

    <div class="flex align-items-center flex-wrap gap-2">
      <div *ngFor="let tier of [1, 2, 3, 4]">
        <div class="flex align-items-center relative tr">
          <p-radioButton [formControlName]="'tier'+index" [value]="tier" [inputId]="'tier' + index + tier"
            styleClass="tierradio" />
          <label [for]="'tier' + index + tier"
            class="absolute left-0 right-0 mx-auto text-center text-gray-600 font-normal">Tier {{ tier }}</label>
        </div>
      </div>
    </div>
    <small class="ng-dirty ng-invalid text-red-500" *ngIf="activity.get('tier'+index)?.invalid &&
      (submitted || activity.get('tier'+index)?.touched)">
      Tier is required
    </small>
  </div>

  <div class="flex flex-column gap-2">
    <b class="block text-left font-bold">Organization Name <span class="font-normal text-bluegray-500">(0 /
        100 characters)</span></b>
    <input type="text" formControlName="organisationName" pInputText placeholder="Eg. Local Food Bank" />
    <small class="ng-dirty ng-invalid text-red-500" *ngIf="activity.get('organisationName')?.invalid &&
    (submitted || activity.get('organisationName')?.touched)">
      Organization Name is required
    </small>
  </div>

  <div class="flex flex-column gap-2">
    <b class="block text-left font-bold">Location</b>
      <input type="text" formControlName="location" pInputText placeholder="Eg. Delhi, India" />
      <small class="ng-dirty ng-invalid text-red-500" *ngIf="activity.get('location')?.invalid &&
      (submitted || activity.get('location')?.touched)">
        Location is required
      </small>
  </div>
  <div class="flex flex-column gap-2">
    <div class="grid">
      <div class="flex-1 flex flex-column gap-2 col-5">
        <b class="block text-left font-bold">Start Date</b>
        <p-calendar [showIcon]="true" [iconDisplay]="'input'" inputId="iconDisplay"
            appendTo="body" styleClass="full-width" formControlName="startDate" /> 
          <small class="text-red-500" *ngIf="activity.get('startDate')?.invalid &&
            (submitted || activity.get('startDate')?.touched)">
            Start Date is required
          </small>
      </div>
      <div class="flex-1 flex flex-column gap-2 col-5">
        <b class="block text-left font-bold">End Date</b>
        <p-calendar [showIcon]="true" [iconDisplay]="'input'" inputId="iconDisplay"
            appendTo="body" styleClass="full-width" formControlName="endDate" /> 
          <small class="text-red-500" *ngIf="activity.get('endDate')?.invalid &&
            (submitted || activity.get('endDate')?.touched)">
            End Date is required
          </small>
      </div>
    </div>
  </div>

  <div class="flex flex-column gap-2">
    <b class="block text-left font-bold">Position & description (please frame your response in bullet points) <span
        class="font-normal text-bluegray-500">(0 / 50 characters)</span></b>
    <textarea type="text" formControlName="positionInActivity" [maxlength]="50" pInputTextarea placeholder="Eg. Team Leader"></textarea> 
    <small class="ng-dirty ng-invalid text-red-500" *ngIf="activity.get('positionInActivity')?.invalid &&
    (submitted || activity.get('positionInActivity')?.touched)">
      Description is required
    </small>
  </div>

</div>
